import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { dateLabel } from '@/components/stokvel/format';

export const StokvelSettingsPanel = () => {
  const [st, setSt] = useState(null);
  const [tiers, setTiers] = useState('');
  const [cap, setCap] = useState('80');
  const [year, setYear] = useState(new Date().getFullYear());
  const [payout, setPayout] = useState('');

  const load = useCallback(async () => {
    try {
      const d = (await axios.get(`${API}/stokvel/settings`)).data;
      setSt(d); setTiers(d.tiers.join(', ')); setCap(String(d.emergency_cap_pct));
    } catch (e) { toast.error(e.response?.data?.detail || 'Failed to load settings'); }
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { setPayout(st?.payout_dates?.[String(year)] || ''); }, [st, year]);

  const save = async (body, msg) => {
    try { setSt((await axios.put(`${API}/stokvel/settings`, body)).data); toast.success(msg); }
    catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); }
  };

  if (!st) return <p className="text-sm text-stone-500">Loading…</p>;
  return (
    <div className="grid md:grid-cols-2 gap-6 max-w-4xl">
      <div className="border border-stone-200 rounded-lg p-4 space-y-3">
        <h3 className="font-semibold text-stone-800">Payout date per year</h3>
        <div className="grid grid-cols-2 gap-2">
          <div><Label className="text-xs">Year</Label><Input type="number" value={year} onChange={e => setYear(Number(e.target.value))} data-testid="stokvel-payout-year-input" /></div>
          <div><Label className="text-xs">Payout date</Label><Input type="date" value={payout} onChange={e => setPayout(e.target.value)} data-testid="stokvel-payout-date-input" /></div>
        </div>
        <Button onClick={() => save({ payout_year: year, payout_date: payout || null }, 'Payout date saved')} className="bg-stone-800 text-white" data-testid="stokvel-payout-save">Save payout date</Button>
        <ul className="text-xs text-stone-600 space-y-0.5" data-testid="stokvel-payout-list">
          {Object.entries(st.payout_dates || {}).sort().map(([y, d]) => <li key={y}>{y}: <b>{dateLabel(d)}</b></li>)}
        </ul>
      </div>
      <div className="border border-stone-200 rounded-lg p-4 space-y-3">
        <h3 className="font-semibold text-stone-800">Contribution tiers &amp; limits</h3>
        <div><Label className="text-xs">Monthly tiers (R, comma separated)</Label><Input value={tiers} onChange={e => setTiers(e.target.value)} data-testid="stokvel-tiers-input" /></div>
        <div><Label className="text-xs">Emergency withdrawal cap (% of capital)</Label><Input type="number" min="0" max="100" value={cap} onChange={e => setCap(e.target.value)} data-testid="stokvel-cap-input" /></div>
        <Button onClick={() => save({ tiers: tiers.split(',').map(t => Number(t.trim())).filter(n => n > 0), emergency_cap_pct: Number(cap) }, 'Settings saved')}
          className="bg-stone-800 text-white" data-testid="stokvel-tiers-save">Save</Button>
        <p className="text-xs text-stone-500">Staff can only see the Stokvel tab when "TMC Stokvel access" is switched on in their user settings.</p>
      </div>
    </div>
  );
};
